/**
 * One-shot flag: user explicitly confirmed deleting every mission in a campaign.
 * Allows useSprintSync / useSaveManagement to persist an empty task list (normally blocked).
 */
const intentionalEmptySaveIds = new Set();

export function markIntentionalEmptyTasksSave(sprintId) {
  if (sprintId) intentionalEmptySaveIds.add(sprintId);
}

export function shouldAllowEmptyTasksSave(sprintId) {
  return !!(sprintId && intentionalEmptySaveIds.has(sprintId));
}

export function clearIntentionalEmptyTasksSave(sprintId) {
  if (sprintId) intentionalEmptySaveIds.delete(sprintId);
}
